import React, { useState, useMemo } from 'react';

import { useEffect } from 'react';
import { showErrorAlert } from '../../../../utils/alerts';
import { usersByApartment } from '../../../../utils/services/userService';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import UsersList from '../../../../components/UsersList';

const UsersByApartment = (props) => {
  const { apartmentId } = props.match.params;
  const { apartmentName } = props.location.state;

  const [users, setUsers] = useState([]);
  const [searchUser, setSearchUser] = useState('');

  const getResidents = async () => {
    try {
      const users = await usersByApartment(apartmentId);
      if (users.length === 0) {
        await showErrorAlert('Error', 'No hemos encontrado usuarios registrados.');
      }
      setUsers(users);
    } catch (error) {
      console.error('Error', error);
      showErrorAlert('Error', error.message);
    }
  };

  const filteredUsers = useMemo(() => {
    const search = (searchUser || '').toLowerCase();

    return users.filter((item) => {
      const { cedula, name, email, tags } = item.user;

      return (
        (cedula && cedula.toString().toLowerCase().includes(search)) ||
        (name && name.toLowerCase().includes(search)) ||
        (email && email.toLowerCase().includes(search)) ||
        (Array.isArray(tags) &&
          tags.some(
            (t) =>
              (t?.tag && t.tag.toLowerCase().includes(search)) || (t?.type && t.type.toLowerCase().includes(search)),
          ))
      );
    });
  }, [users, searchUser]);

  useEffect(() => {
    getResidents();
  }, []);

  return (
    <div>
      <div className="mb-3 row text-form">
        <h2>
          Usuarios del apartamento <b>{apartmentName}</b>
        </h2>
      </div>
      <div className="d-flex justify-content-start mb-4">
        <input
          type="text"
          placeholder="Buscar residente"
          value={searchUser}
          onChange={(e) => {
            const value = e.target.value;
            setSearchUser(value);
          }}
          className="w-50 p-3 border rounded"
        />
      </div>
      <UsersList users={filteredUsers} onUserSave={getResidents} />
    </div>
  );
};
UsersByApartment.propTypes = {
  apartmentId: PropTypes.text,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default withRouter(UsersByApartment);
